import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractHttpService } from "./http-abstract-service";
import { PackageApiResponse, SubmitData } from "../dto";
import { Config as FacetecConfig } from "src/assets/Config";

@Injectable({
    providedIn: "root",
})

export class HttpPackageService extends AbstractHttpService {
    constructor(http: HttpClient) {
        super(http, "");
    }

    public getPackage(ref: string) {
        const path = `/package/get-package/${ref}`;
        return super.get<PackageApiResponse>(path);
    }
}
